import PropTypes from "prop-types"

function TooltipItem({ label, color, formatter, value }) {
  return <div className="components_charts_color-tooltip-item">
    <span className="color" style={{ backgroundColor: color }} />
    <span className="dimension">{label}</span>
    <span className="value">{formatter ? formatter(value) : value}</span>
  </div>
}

TooltipItem.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  formatter: PropTypes.func,
  value: PropTypes.number,
}

export default TooltipItem
